import { defineMessages } from 'react-intl';
import { SampleOrderSteps } from '../../SampleOrderSteps/types';

export const titles = defineMessages<Exclude<SampleOrderSteps, SampleOrderSteps.Finished>>({
  [SampleOrderSteps.SelectSamples]: {
    defaultMessage: 'Wähle bis zu 10 Muster',
    id: 'sampleOrder.step.title.selectSamples',
  },
  [SampleOrderSteps.PersonalDataForm]: {
    defaultMessage: 'Wohin dürfen wir liefern?',
    id: 'sampleOrder.step.title.enterData',
  },
  [SampleOrderSteps.Review]: {
    defaultMessage: 'Überprüfe deine Angaben',
    id: 'sampleOrder.step.title.review',
  },
});

export const descriptions = defineMessages<Exclude<SampleOrderSteps, SampleOrderSteps.Finished>>({
  [SampleOrderSteps.SelectSamples]: {
    defaultMessage: 'Such dir deine Favoriten aus',
    id: 'sampleOrder.step.description.selectSamples',
  },
  [SampleOrderSteps.PersonalDataForm]: {
    defaultMessage: 'Sag uns, wohin wir die Muster schicken dürfen.',
    id: 'sampleOrder.step.description.enterData',
  },
  [SampleOrderSteps.Review]: {
    defaultMessage:
      'Du hast hier die Möglichkeit deine Angaben zu überprüfen und ggf. zu korrigieren.',
    id: 'sampleOrder.step.description.review',
  },
});
